"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugCacheLogger = void 0;
/* eslint-disable no-console */
var _constants_1 = require("../_constants");
var DebugCacheLogger = /** @class */ (function () {
    function DebugCacheLogger(_a) {
        var _this = this;
        var debug = _a.debug;
        this.opened = false;
        this.requestCacheKey = '';
        this.logsArray = [];
        this.debug = false;
        this.openLogsGroup = function (_a) {
            var requestCacheKey = _a.requestCacheKey;
            if (!_this.debug) {
                return;
            }
            _this.opened = true;
            _this.requestCacheKey = requestCacheKey;
        };
        this.writeLogs = function () {
            console.groupCollapsed("%cRequest Cache Info " + _this.requestCacheKey, _constants_1.LOGS_STYLES.main);
            _this.logsArray.forEach(function (_a) {
                var log = _a.log, type = _a.type;
                console.log("%c" + log, _constants_1.LOGS_STYLES[type]);
            });
            console.groupEnd();
        };
        this.closeLogsGroup = function () {
            if (!_this.debug) {
                return;
            }
            _this.writeLogs();
            _this.opened = false;
        };
        this.logParams = function (_a) {
            var params = _a.params;
            if (!_this.debug) {
                return;
            }
            _this.logsArray.push({
                log: "Cache Params: " + params,
                type: 'main',
            });
        };
        this.logCacheIsMatched = function (_a) {
            var cacheMatched = _a.cacheMatched;
            if (!_this.debug) {
                return;
            }
            _this.logsArray.push({
                log: "Cache is matched: " + cacheMatched,
                type: cacheMatched ? 'success' : 'warning',
            });
        };
        this.logCacheIsExpired = function () {
            if (!_this.debug) {
                return;
            }
            _this.logsArray.push({
                log: 'Cache is expired',
                type: 'warning',
            });
        };
        this.logUpdatedCache = function () {
            if (!_this.debug) {
                return;
            }
            _this.logsArray.push({
                log: 'Cache is updated',
                type: 'success',
            });
        };
        this.logNotUpdatedCache = function (_a) {
            var response = _a.response;
            if (!_this.debug) {
                return;
            }
            _this.logsArray.push({
                log: "Cache is not updated: response with error: " + response,
                type: 'error',
            });
        };
        this.logDisabledCache = function () {
            if (!_this.debug) {
                return;
            }
            _this.logsArray.push({
                log: 'Cache is disabled',
                type: 'warning',
            });
        };
        this.debug = debug;
    }
    return DebugCacheLogger;
}());
exports.DebugCacheLogger = DebugCacheLogger;
